import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getJson, postJson } from '../../helpers/RequestsHelper';
import WalletConnect from './WalletConnect';

const RewardsPage = (props) => {

  const { t } = useTranslation()

  const [balance, setBalance] = useState()
  const [rewards, setRewards] = useState(props.rewards)
  const [loadingRewards, setLoadingRewards] = useState(true)
  const [promoCode, setPromoCode] = useState()
  const [error, setError] = useState()

  document.title = t("titleappname") + t("title_rewards")

  useEffect(() => {
    if (balance === undefined) {
      let isApiSubscribed = true;

      async function readRewardsInternal() {
        console.log("readRewards")
        let url = process.env.REACT_APP_SERVER_BASE_URL + "/rewards"
        const result = await getJson(url);

        if (isApiSubscribed) {
          setBalance(result.balance)
          setRewards(result.rewards)

          setLoadingRewards(false)
        }
      }

      console.log("useEffect")
      readRewardsInternal()

      const urlParams = new URLSearchParams(window.location.search)
      const promoCode = urlParams.get('code')
      if (promoCode) {
        setPromoCode(promoCode);
        if (!window.profileSent) {
          window.profileSent = true
          //TODO: Is there a better place for that. In other case it will not give the first login reward and will not
          postJson(process.env.REACT_APP_SERVER_BASE_URL +"/updateProfile", {});
        }
      }

      return () => {
        //TODO: cancel the request before component unmounts
        isApiSubscribed = false
      };
    }
  })

  const readRewards = async () => {
    //TODO: How to check if it's mounted
    console.log("readRewards")
    let url = process.env.REACT_APP_SERVER_BASE_URL + "/rewards"
    const result = await getJson(url);

    setBalance(result.balance)
    setRewards(result.rewards)

    setLoadingRewards(false)
  }

  const typeToString = (type) => {
    switch (type) {
      case "daily":
        return "Daily"
      case "withdraw":
        return "Withdrawal"
      case "newuser":
        return "Welcome"
      case "7days":
        return "7-day streak"
      case "30days":
        return "Monthly streak"
      default:
        return type
    }
  }


  const withdrawToWallet = async (walletAddress) => {

    let url = process.env.REACT_APP_SERVER_BASE_URL + "/rewards/withdraw"
    try {
      setBalance(0)
      await postJson(url, { recepient: walletAddress })
      await readRewards()
      await props.loadRewards()
      //TODO: Use only one
    } catch (error) {
      //setError("Not successful transaction. Please try again in 1 minute or write us in Discord or email.")
    }
  }

  const redeemPromoCode = async () => {
    let url = process.env.REACT_APP_SERVER_BASE_URL + "/rewards/promo"
    try {
      if (promoCode) {
        setPromoCode("")
        const result = await postJson(url, { promoCode: promoCode.trim() })
        if (result.code == "USED") {
          setError("This code has already been used.")
        } else {
          await readRewards()
          await props.loadRewards()
        }
      }
    } catch (error) {
      //setError("AAA" + error)
    }
  }


  if (loadingRewards) {
    return <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  } else {
    return <div >

      <h3>{t("title_rewards")}</h3>

      <br />
      <h4>
        Balance: {balance.balance} $TIME
      </h4>
      <br />
      <WalletConnect balance={balance.balance} withdrawToWallet={withdrawToWallet} />
      <br />
      {error ? <div className="text-danger"><b>{error}</b><br /></div> :
        <div className="wrap-input100 validate-input">
          <input className="form-control"
            id="promoCode"
            placeholder="Type promo code"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            style={{ width: "auto", display: "inline-block", marginRight: "20px" }} />
          <button className={promoCode && promoCode.length > 0 ? "submit-btn" : "submit-btn-2"} onClick={redeemPromoCode}>Redeem</button>
        </div>
      }
      <br />
      <div>
        <i>Rewards I've won in the last 30 days. (Time until next daily reward: {new moment(balance.timeLeftForDaily).format("HH:mm")})</i>
      </div>
      <br />
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Reward</th>
            <th scope="col">$TIME</th>
          </tr>
        </thead>
        <tbody>
          {rewards.map(reward =>
            <tr key={reward._id}>
              <td>{new moment.utc(reward.ts).format("L")}</td>
              <td>{typeToString(reward.type)} {reward.transactionHash ? <a href={`https://polygonscan.com/tx/${reward.transactionHash}`} target='_blank'>Check Status</a> : ""}</td>
              <td>{reward.amount > 0 ? reward.amount : ""}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  }

}

export default RewardsPage
